module.exports = __webpack_public_path__ + "resources/img/ic-macao.2cf537bd.png";